<template>
  <div
    class="flex flex-col justify-center items-center fixed z-50 inset-0 bg-opacity-25 bg-black"
    @click.self="close"
  >
    <div class="form-card relative">
      <button
        class="system-button absolute right-4 top-4"
        @click.prevent="close"
      >
        <close-icon class="w-8 fill-current" />
      </button>

      <form @submit.prevent="save">
        <div class="flex flex-col w-full mt-6">
          <label for="street">Calle</label>
          <input id="street" type="text" v-model="form.street" />
          <validation-errors :errors="errorFor('street')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="exterior_number">Número exterior</label>
          <input
            id="exterior_number"
            type="text"
            v-model="form.exterior_number"
          />
          <validation-errors
            :errors="errorFor('exterior_number')"
          ></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="interior_number">Número interior(opcional)</label>
          <input
            id="interior_number"
            type="text"
            v-model="form.interior_number"
          />
          <validation-errors
            :errors="errorFor('interior_number')"
          ></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="neighborhood">Colonia</label>
          <input id="neighborhood" type="text" v-model="form.neighborhood" />
          <validation-errors
            :errors="errorFor('neighborhood')"
          ></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="city">Ciudad</label>
          <input id="city" type="text" v-model="form.city" />
          <validation-errors :errors="errorFor('city')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="state">Estado</label>
          <custom-input-select
            v-model="form.state_id"
            id="state"
            :options="getStateOptions()"
          />

          <validation-errors :errors="errorFor('state_id')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="zip_code">Código postal</label>
          <input id="zip_code" type="text" v-model="form.zip_code" />
          <validation-errors :errors="errorFor('zip_code')"></validation-errors>
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Agregar" }}
        </primary-button>
      </form>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
import api from "@/api";
export default {
  name: "Address Modal",

  data() {
    return {
      states: null,
      form: {
        street: "",
        exterior_number: "",
        interior_number: "",
        neighborhood: "",
        city: "",
        state: "",
        zip_code: "",
        branch_id: null,
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
    };
  },

  props: {
    address: Object,
    clientId: Number,
  },

  mixins: [validationErrors],

  created() {
    if (this.address) {
      this.isEditing = true;
      this.form = JSON.parse(JSON.stringify(this.address));
    }

    this.loadStates();
  },

  methods: {
    close() {
      this.$emit("close");
    },

    async loadStates() {
      this.loading = true;

      try {
        this.states = await api.resources.getStates();
      } catch (error) {}

      this.loading = false;
    },

    getStateOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      if (this.states) {
        this.states.forEach((state) => {
          options.push({
            value: state.id,
            label: state.name,
          });
        });
      }

      return options;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createAddress();
      } else {
        this.updateAddress();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.street) {
        this.errors["street"] = ["Campo requerido"];
      }

      if (!this.form.exterior_number) {
        this.errors["exterior_number"] = ["Campo requerido"];
      }

      if (!this.form.exterior_number) {
        this.errors["exterior_number"] = ["Campo requerido"];
      }

      if (!this.form.city) {
        this.errors["city"] = ["Campo requerido"];
      }

      if (!this.form.state_id) {
        this.errors["state_id"] = ["Campo requerido"];
      }

      if (!this.form.zip_code) {
        this.errors["zip_code"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createAddress() {
      this.loadingForm = true;

      try {
        const response = await api.clients.createAddress(
          this.clientId,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$emit("addressAdded", response.address);
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateAddress() {
      this.loadingForm = true;

      try {
        const response = await api.clients.updateAddress(
          this.address.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$emit("addressAdded", response.address);
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>